/**************************************************************************************************/
/*   File: /src/app/shared/models/result.with.notify.ts                                           */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 1st 2019                                                          */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 01 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Result } from './result';
/**
 * The result with notify
 */
export class ResultWithNotify extends Result {
    /**
     * The boolean of the notified user
     */
    notified: boolean;
}   